import { Component, OnInit, ViewChild } from '@angular/core';
import { CodigosBeneficiosFiscaisService } from '../../../services/codigos-beneficios-fiscais.service';
import { ModalCadastroComponent } from '../../../shared/modal-cadastro/modal-cadastro.component';
import { FormArray, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-importacao-detalhar-adicao',
  templateUrl: './importacao-detalhar-adicao.component.html',
  styleUrls: ['./importacao-detalhar-adicao.component.css']
})
export class ImportacaoDetalharAdicaoComponent extends ModalCadastroComponent implements OnInit {
  formAdicao = null;
  currencyOptions = { precision: 2, prefix: '', allowNegative: false };
  codigosCreditoPresumido = [];
  unidadeEmpresa = null;
  adicao = null;

  constructor(
    private codigosBeneficiosFiscaisService: CodigosBeneficiosFiscaisService,
  ) {
    super();
  }

  @ViewChild('modalConsultar', { static: true }) modalConsultar;
  
  ngOnInit() {
    this.carregaCodigoCreditoPresumido();
  }

  show(props) {
    this.modalConsultar.show();
    this.unidadeEmpresa = props.unidadeEmpresa;
    this.adicao = props.adicao.value;
    this.formAdicao = new FormGroup({
      mercadorias: new FormArray([]),
    });

    for (const mercadoria of props.adicao.value.mercadorias) {
      (this.formAdicao.get('mercadorias') as FormArray).push(new FormGroup({
        referenciaItem: new FormControl(mercadoria.referenciaItem),
        aliquotaICMSSaida: new FormControl(mercadoria.aliquotaICMSSaida),
        cBenefSaida: new FormControl(mercadoria.cBenefSaida),
        cCredPresumidoSaida: new FormControl(mercadoria.cCredPresumidoSaida),
        descricaoMercadoria: new FormControl(mercadoria.descricaoMercadoria),
        pCredPresumidoSaida: new FormControl(mercadoria.pCredPresumidoSaida),
        reducaoBCICMSSaida: new FormControl(mercadoria.reducaoBCICMSSaida),
        unidadeMedida: new FormControl(mercadoria.unidadeMedida),
      }));
    }
  }

  salvar() {
    this.closed.emit(this.formAdicao);
  }

  voltar() {
    this.closed.emit(null);
  }

  async carregaCodigoCreditoPresumido() {
    try {
      this.loading['codigosCreditoPresumido'] = true;
      this.codigosCreditoPresumido = await this.codigosBeneficiosFiscaisService.getCreditoPresumido().toPromise();
    } catch (error) {
      console.error(error);
    } finally {
      this.loading['codigosCreditoPresumido'] = false;
    }
  }

  calcularCst(mercadoria) {
    // Conforme regra do backend, ComexCommandHandler, função ConverterItemParaNotaSaidaImportacao
    if ([1, 4].includes(this.unidadeEmpresa?.crt)) {
      return '900';
    } else if (!mercadoria.get('aliquotaICMSSaida').value) {
      return '41';
    } else if (mercadoria.get('reducaoBCICMSSaida').value) {
      return '20';
    } else {
      return '00';
    }
  }

  get tituloModal() {
    return `Alíquota de ICMS e cBenef por item - NCM: ${this.adicao?.codigoNCM} - Adição ${this.adicao?.numeroAdicao}`;
  }
}
